export const get_api = () => {
    if (typeof window === 'undefined'){
        return 'http://venture_v1_api:3000'
    } else return 'https://api.venturedesign.se'
}
export const API_ENDPOINT = get_api();
export const PORT = 53275;
export const CDN_URL = 'https://cdn.venturedesign.se';
